export const dashboardEn = {
  DASHBOARD: 'Dashboard',
  DOWNLOAD_REPORT: 'Download Report',
  DEBTOR_COLLECTION_TITLE: 'Collections - Debtor Open AR',
  CREDIT_REQUEST: 'Credit Requests',
  CLIENT_DEBTOR_REQUEST: 'Client:Debtor Relationship Request',
  NEW_DEBTOR_REQUEST: 'New Debtor Request',
  VIEW_MORE: 'View More',
  FEE_EARNINGS: 'Fee Earnings',
  FUNDING: 'Funding',
  TOTAL_AMOUNT_FUNDED: 'Total amount funded',
  INVOICE_OVERVIEW: 'Invoice Overview',
  TOTAL: 'Total',
  PAST_DUE_INVOICES: 'Past Due Invoices',
  //START MICHAEL
  DASHBOARD_OVERVIEW: 'Dashboard Overview',
  AGING_BUCKETS_AMOUNTS: 'Aging Buckets Amounts',
  CHART_OPTIONS: 'Chart Options',
  AGING_BUCKETS_PERCENTAGE: 'Aging Buckets Percentage',
  FACTOR_PORTFOLIO: 'Factor Portfolio',
  DAILY_VOLUME: 'Daily Volume',
  APPROVED_INVOICE_AMOUNT: 'Approved Invoice Amount',
  APPROVED_INVOICE_AMOUNT_TOOLTIP: 'The total amount of invoices approved for funding but not yet funded.',
  FUNDED_INVOICE_AMOUNT: 'Funded Invoice Amount',
  FUNDED_INVOICE_AMOUNT_TOOLTIP: 'The current daily amount of invoices that have been successfully funded.',
  RECEIVED_PAYMENTS_AMOUNT: 'Received Payments Amount',
  RECEIVED_PAYMENTS_AMOUNT_TOOLTIP: 'Total amount applied to invoices today (from midnight to now, in the factor\'s timezone).',
  INVOICE_SINGULAR: 'invoice',
  INVOICES_PLURAL: 'invoices',
  TOTAL_AR: 'Total AR',
  AR_BALANCE: 'AR Balance',
  ESCROW_BALANCE: 'Escrow Balance',
  CASH_RESERVE_BALANCE: 'Cash Reserve Balance',
  RANK: 'Rank',
  CLIENT_NAME: 'Client Name',
  DEBTOR_NAME: 'Debtor Name',
  NFE_AMOUNT: 'NFE Amount',
  NO_CLIENTS_CREATED: 'No clients created',
  NO_DEBTORS_CREATED: 'No debtors created',

  DEBTOR_DASHBOARD_SUMMARY: 'Debtor Snapshot',
  DEBTOR_OUTSTANDING_BALANCE: 'Outstanding Balance',
  DEBTOR_OUTSTANDING_BALANCE_HINT: 'Currently owed',
  DEBTOR_LAST_INVOICE_PURCHASED: 'Last Invoice Purchased Date',
  DEBTOR_LAST_INVOICE_PURCHASED_HINT: 'Most recent invoice funded',
  DEBTOR_LAST_INVOICE_PURCHASED_EMPTY_HINT: 'No invoices have been funded yet',
  DEBTOR_LAST_PAYMENT_APPLIED: 'Last Payment Applied Date',
  DEBTOR_LAST_PAYMENT_APPLIED_HINT: 'Most recent payment applied',
  DEBTOR_LAST_PAYMENT_APPLIED_EMPTY_HINT: 'No payments have been applied yet',
  DEBTOR_AVAILABLE_CREDIT: 'Available Credit',
  DEBTOR_AVAILABLE_CREDIT_HINT: 'Credit Limit - Outstanding',
  DEBTOR_AVERAGE_DAYS_TO_PAY_HINT: 'All-time average',
  DEBTOR_OLDEST_CURRENT_INVOICE: 'Oldest Current Invoice',
  DEBTOR_OLDEST_CURRENT_INVOICE_HINT: 'Since becoming open',

  CLIENT_DASHBOARD_SUMMARY: 'Client Snapshot',
  CLIENT_LAST_INVOICE_PURCHASED: 'Last Invoice Purchased Date',
  CLIENT_LAST_INVOICE_PURCHASED_HINT: 'Most recent invoice funded',
  CLIENT_LAST_INVOICE_PURCHASED_EMPTY_HINT: 'No invoices have been funded yet',
  CLIENT_LAST_PAYMENT_APPLIED: 'Last Payment Applied Date',
  CLIENT_LAST_PAYMENT_APPLIED_HINT: 'Most recent payment applied',
  CLIENT_LAST_PAYMENT_APPLIED_EMPTY_HINT: 'No payments have been applied yet',

  TOP_N_CLIENTS_BY_NFE: (n?: string) => `Top ${n} Clients by NFE`,
  TOP_N_DEBTORS_BY_NFE: (n?: string) => `Top ${n} Debtors by Open AR`,
  //END MICHAEL

  // Error messages for dashboard components
  ERROR_LOADING_PORTFOLIO: 'Error loading portfolio data',
  ERROR_LOADING_AGING_BUCKET: 'Error loading aging bucket data',

  //START PATRICIO
  AMOUNT_INELIGIBLE_DISPUTABLE: 'Ineligible/Disputed',
  TOTAL_FUNDS_EMPLOYED: 'Funds Employed',
  NET_FUNDS_EMPLOYED: 'Net Funds Employed',
  AVAILABLE_RESERVE: 'Available Reserve',
  CASH_RESERVE: 'Cash Reserve',
  UNAPPLIED_RESERVE: 'Unapplied Reserve',
  //END PATRICIO

  //START PORTFOLIO RISK
  PORTFOLIO_RISK_TAB_OVERVIEW: 'Overview',
  PORTFOLIO_RISK_TAB: 'Portfolio Risk',
  PORTFOLIO_RISK_AS_OF: (date: string) => `As of ${date}`,
  PORTFOLIO_RISK_NOT_FUNDED_TITLE: 'Not Funded in 21+ Days',
  PORTFOLIO_RISK_NEGATIVE_CASH_RESERVE_TITLE: 'Negative Cash Reserve',
  PORTFOLIO_RISK_VIEW_ALL: 'View all',
  PORTFOLIO_RISK_NOT_FUNDED_EMPTY: 'Every client with open AR was funded in the last 21 days.',
  PORTFOLIO_RISK_NEGATIVE_CASH_RESERVE_EMPTY: 'No client has a negative cash reserve.',
  PORTFOLIO_RISK_NOT_FUNDED_SUBTITLE: 'Clients with open AR and no funding in 21 days',
  PORTFOLIO_RISK_NEGATIVE_CASH_RESERVE_SUBTITLE: 'Clients whose cash reserve balance is below zero',
  PORTFOLIO_RISK_CLIENTS_COUNT: (count: number) => (count === 1 ? '1 client' : `${count} clients`),
  PORTFOLIO_RISK_AGING: 'Aging',
  PORTFOLIO_RISK_LAST_FUNDED: 'Last Funded',
  PORTFOLIO_RISK_DAYS_SINCE: 'Days Since',
  PORTFOLIO_RISK_NEVER_FUNDED: 'Never funded',
  PORTFOLIO_RISK_LAST_TRANSACTION: 'Last Transaction',
  PORTFOLIO_RISK_NEGATIVE_SINCE: 'Negative Since',
  PORTFOLIO_RISK_BALANCE: 'Balance',
  PORTFOLIO_RISK_AMOUNT: 'Amount',
  PORTFOLIO_RISK_INVOICE_COUNT: (count: number) => (count === 1 ? '1 invoice' : `${count} invoices`),
  PORTFOLIO_RISK_SHOW_ALL: 'Show all',
  PORTFOLIO_RISK_OPEN_INVOICES: 'Open AR Invoices',
  PORTFOLIO_RISK_TRANSACTIONS: 'Cash Reserve Transactions',
  PORTFOLIO_RISK_CASH_RESERVE_BALANCE: 'Cash Reserve Balance',
  PORTFOLIO_RISK_OPEN_INVOICES_AR: 'Open invoices',
  PORTFOLIO_RISK_OTHER_AR: 'Other AR (not tied to open invoices)',
  PORTFOLIO_RISK_MODE_NEGATIVE: 'Negative',
  PORTFOLIO_RISK_MODE_LAST_30_DAYS: 'Last 30 Days',
  PORTFOLIO_RISK_NEGATIVE_NOTE: 'Last 10 transactions that reduced the cash reserve, newest first.',
  PORTFOLIO_RISK_LAST_30_DAYS_NOTE: (date: string, openingBalance?: string) =>
    `All cash reserve transactions since ${date}, newest first.${openingBalance ? ` Opening balance ${openingBalance}.` : ''}`,
  PORTFOLIO_RISK_NO_TRANSACTIONS: 'No transactions in this period.',
  PORTFOLIO_RISK_NO_LEDGER_PERMISSION: 'You need permission to read ledgers to see the transactions.',
  PORTFOLIO_RISK_NO_OPEN_INVOICES: 'No open invoices',
  PORTFOLIO_RISK_ONLY_OTHER_AR: (amount: string) =>
    `This client's open AR (${amount}) is Other AR, not tied to open invoices.`,
  PORTFOLIO_RISK_NO_TRANSACTIONS_LAST_30_DAYS: 'No transactions in the last 30 days',
  PORTFOLIO_RISK_NO_TRANSACTIONS_HINT: 'Switch to Negative to see the last transactions that reduced the cash reserve.',
  PORTFOLIO_RISK_BUCKET_FILTER: 'Click to filter invoices',
  PORTFOLIO_RISK_BUCKET_SHOW_ALL: 'Click again to show all',
  PORTFOLIO_RISK_BUCKET_LABEL: (range: string, count: string, amount: string) => `${range} days, ${count}, ${amount}`,
  //END PORTFOLIO RISK
}

export const dashboardEs: typeof dashboardEn = {
  DASHBOARD: 'Tablero',
  DOWNLOAD_REPORT: 'Descargar informe',
  DEBTOR_COLLECTION_TITLE: 'Colecciones - Deudor Open AR',
  CREDIT_REQUEST: 'Solicitudes de crédito',
  CLIENT_DEBTOR_REQUEST: 'Cliente: Solicitud de relación de deudor',
  NEW_DEBTOR_REQUEST: 'Nueva solicitud de deudor',
  VIEW_MORE: 'Ver más',
  FEE_EARNINGS: 'Ganancias de tarifas',
  FUNDING: 'Financiamiento',
  TOTAL_AMOUNT_FUNDED: 'Monto total financiado',
  INVOICE_OVERVIEW: 'Resumen de facturas',
  TOTAL: 'Total',
  PAST_DUE_INVOICES: 'Facturas vencidas',
  //START MICHAEL
  DASHBOARD_OVERVIEW: 'Resumen del tablero',
  AGING_BUCKETS_AMOUNTS: 'Montos por tramos de antigüedad',
  CHART_OPTIONS: 'Opciones de gráfico',
  AGING_BUCKETS_PERCENTAGE: 'Porcentaje por tramos de antigüedad',
  FACTOR_PORTFOLIO: 'Portafolio de factoring',
  DAILY_VOLUME: 'Volumen diario',
  APPROVED_INVOICE_AMOUNT: 'Monto de Facturas Aprobadas',
  APPROVED_INVOICE_AMOUNT_TOOLTIP: 'El total de facturas aprobadas para financiamiento pero aún no financiadas.',
  FUNDED_INVOICE_AMOUNT: 'Monto de Facturas Financiadas',
  FUNDED_INVOICE_AMOUNT_TOOLTIP: 'El monto diario actual de facturas que han sido financiadas.',
  RECEIVED_PAYMENTS_AMOUNT: 'Monto de Pagos Recibidos',
  RECEIVED_PAYMENTS_AMOUNT_TOOLTIP: 'Monto total aplicado a facturas hoy (desde medianoche hasta ahora, en la zona horaria del factor).',
  INVOICE_SINGULAR: 'factura',
  INVOICES_PLURAL: 'facturas',
  TOTAL_AR: 'Total AR',
  AR_BALANCE: 'Saldo de AR',
  ESCROW_BALANCE: 'Saldo de depósito en garantía',
  CASH_RESERVE_BALANCE: 'Saldo de reserva de efectivo',
  RANK: 'Posición',
  CLIENT_NAME: 'Nombre del Cliente',
  DEBTOR_NAME: 'Nombre del Deudor',
  NFE_AMOUNT: 'Monto NFE',
  NO_CLIENTS_CREATED: 'No hay clientes creados',
  NO_DEBTORS_CREATED: 'No hay deudores creados',

  DEBTOR_DASHBOARD_SUMMARY: 'Resumen del deudor',
  DEBTOR_OUTSTANDING_BALANCE: 'Saldo pendiente',
  DEBTOR_OUTSTANDING_BALANCE_HINT: 'Actualmente adeudado',
  DEBTOR_LAST_INVOICE_PURCHASED: 'Fecha de última factura comprada',
  DEBTOR_LAST_INVOICE_PURCHASED_HINT: 'Factura financiada más reciente',
  DEBTOR_LAST_INVOICE_PURCHASED_EMPTY_HINT: 'Todavía no se financió ninguna factura',
  DEBTOR_LAST_PAYMENT_APPLIED: 'Fecha de último pago aplicado',
  DEBTOR_LAST_PAYMENT_APPLIED_HINT: 'Pago aplicado más reciente',
  DEBTOR_LAST_PAYMENT_APPLIED_EMPTY_HINT: 'Todavía no se aplicó ningún pago',
  DEBTOR_AVAILABLE_CREDIT: 'Crédito disponible',
  DEBTOR_AVAILABLE_CREDIT_HINT: 'Límite de crédito - Saldo pendiente',
  DEBTOR_AVERAGE_DAYS_TO_PAY_HINT: 'Promedio histórico',
  DEBTOR_OLDEST_CURRENT_INVOICE: 'Factura vigente más antigua',
  DEBTOR_OLDEST_CURRENT_INVOICE_HINT: 'Desde que quedó abierta',

  CLIENT_DASHBOARD_SUMMARY: 'Resumen del cliente',
  CLIENT_LAST_INVOICE_PURCHASED: 'Fecha de última factura comprada',
  CLIENT_LAST_INVOICE_PURCHASED_HINT: 'Factura financiada más reciente',
  CLIENT_LAST_INVOICE_PURCHASED_EMPTY_HINT: 'Todavía no se financió ninguna factura',
  CLIENT_LAST_PAYMENT_APPLIED: 'Fecha de último pago aplicado',
  CLIENT_LAST_PAYMENT_APPLIED_HINT: 'Pago aplicado más reciente',
  CLIENT_LAST_PAYMENT_APPLIED_EMPTY_HINT: 'Todavía no se aplicó ningún pago',

  TOP_N_CLIENTS_BY_NFE: (n?: string) => `Top ${n} Clientes por NFE`,
  TOP_N_DEBTORS_BY_NFE: (n?: string) => `Top ${n} Deudores por AR Abierto`,
  //END MICHAEL

  // Error messages for dashboard components
  ERROR_LOADING_PORTFOLIO: 'Error cargando datos del portafolio',
  ERROR_LOADING_AGING_BUCKET: 'Error cargando datos de antigüedad',

  //START PATRICIO
  AMOUNT_INELIGIBLE_DISPUTABLE: 'Ineligible/Disputable',
  TOTAL_FUNDS_EMPLOYED: 'Total de fondos empleados',
  NET_FUNDS_EMPLOYED: 'Fondos netos empleados',
  AVAILABLE_RESERVE: 'Reserva disponible',
  CASH_RESERVE: 'Reserva de efectivo',
  UNAPPLIED_RESERVE: 'Reserva no aplicada',
  //END PATRICIO

  //START PORTFOLIO RISK
  PORTFOLIO_RISK_TAB_OVERVIEW: 'Resumen',
  PORTFOLIO_RISK_TAB: 'Riesgo de cartera',
  PORTFOLIO_RISK_AS_OF: (date: string) => `Al ${date}`,
  PORTFOLIO_RISK_NOT_FUNDED_TITLE: 'Sin financiar en 21+ días',
  PORTFOLIO_RISK_NEGATIVE_CASH_RESERVE_TITLE: 'Reserva de efectivo negativa',
  PORTFOLIO_RISK_VIEW_ALL: 'Ver todo',
  PORTFOLIO_RISK_NOT_FUNDED_EMPTY: 'Todos los clientes con Open AR fueron financiados en los últimos 21 días.',
  PORTFOLIO_RISK_NEGATIVE_CASH_RESERVE_EMPTY: 'Ningún cliente tiene reserva de efectivo negativa.',
  PORTFOLIO_RISK_NOT_FUNDED_SUBTITLE: 'Clientes con Open AR y sin financiamiento en 21 días',
  PORTFOLIO_RISK_NEGATIVE_CASH_RESERVE_SUBTITLE: 'Clientes cuya reserva de efectivo está bajo cero',
  PORTFOLIO_RISK_CLIENTS_COUNT: (count: number) => (count === 1 ? '1 cliente' : `${count} clientes`),
  PORTFOLIO_RISK_AGING: 'Antigüedad',
  PORTFOLIO_RISK_LAST_FUNDED: 'Último financiamiento',
  PORTFOLIO_RISK_DAYS_SINCE: 'Días desde',
  PORTFOLIO_RISK_NEVER_FUNDED: 'Nunca financiado',
  PORTFOLIO_RISK_LAST_TRANSACTION: 'Última transacción',
  PORTFOLIO_RISK_NEGATIVE_SINCE: 'Negativa desde',
  PORTFOLIO_RISK_BALANCE: 'Saldo',
  PORTFOLIO_RISK_AMOUNT: 'Monto',
  PORTFOLIO_RISK_INVOICE_COUNT: (count: number) => (count === 1 ? '1 factura' : `${count} facturas`),
  PORTFOLIO_RISK_SHOW_ALL: 'Ver todas',
  PORTFOLIO_RISK_OPEN_INVOICES: 'Facturas de Open AR',
  PORTFOLIO_RISK_TRANSACTIONS: 'Transacciones de la reserva de efectivo',
  PORTFOLIO_RISK_CASH_RESERVE_BALANCE: 'Saldo de la reserva de efectivo',
  PORTFOLIO_RISK_OPEN_INVOICES_AR: 'Facturas abiertas',
  PORTFOLIO_RISK_OTHER_AR: 'Otro AR (no asociado a facturas abiertas)',
  PORTFOLIO_RISK_MODE_NEGATIVE: 'Negativas',
  PORTFOLIO_RISK_MODE_LAST_30_DAYS: 'Últimos 30 días',
  PORTFOLIO_RISK_NEGATIVE_NOTE:
    'Últimas 10 transacciones que redujeron la reserva de efectivo, de la más reciente a la más antigua.',
  PORTFOLIO_RISK_LAST_30_DAYS_NOTE: (date: string, openingBalance?: string) =>
    `Todas las transacciones de la reserva de efectivo desde el ${date}, de la más reciente a la más antigua.${openingBalance ? ` Saldo inicial ${openingBalance}.` : ''}`,
  PORTFOLIO_RISK_NO_TRANSACTIONS: 'No hay transacciones en este período.',
  PORTFOLIO_RISK_NO_LEDGER_PERMISSION: 'Necesitas permiso para leer ledgers para ver las transacciones.',
  PORTFOLIO_RISK_NO_OPEN_INVOICES: 'No hay facturas abiertas',
  PORTFOLIO_RISK_ONLY_OTHER_AR: (amount: string) =>
    `El Open AR de este cliente (${amount}) es Otro AR, no asociado a facturas abiertas.`,
  PORTFOLIO_RISK_NO_TRANSACTIONS_LAST_30_DAYS: 'No hay transacciones en los últimos 30 días',
  PORTFOLIO_RISK_NO_TRANSACTIONS_HINT:
    'Cambia a Negativas para ver las últimas transacciones que redujeron la reserva de efectivo.',
  PORTFOLIO_RISK_BUCKET_FILTER: 'Haz clic para filtrar las facturas',
  PORTFOLIO_RISK_BUCKET_SHOW_ALL: 'Haz clic de nuevo para ver todas',
  PORTFOLIO_RISK_BUCKET_LABEL: (range: string, count: string, amount: string) => `${range} días, ${count}, ${amount}`,
  //END PORTFOLIO RISK
}
